"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InstagramEmbed1Schema = void 0;
exports.InstagramEmbed1Schema = {
    "$id": "https://www.redbull.com/schemas/content/ext/services/instagram-embed/1.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "InstagramEmbed1",
    "description": "Embed an instagram post",
    "type": "object",
    "properties": {
        "type": {
            "type": "string",
            "enum": [
                "rrn:content:ext:services:instagram-embed:1"
            ]
        },
        "attributes": {
            "type": "object",
            "properties": {
                "hideCaption": {
                    "type": "boolean",
                    "default": false
                },
                "href": {
                    "type": "string",
                    "description": "URL of Instagram post. Open an image on instagram and copy the URL from your browser."
                }
            },
            "required": [
                "hideCaption",
                "href"
            ]
        }
    },
    "required": [
        "attributes",
        "type"
    ]
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiMS5zY2hlbWEuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi8uLi9zcmMvbW9kdWxlcy9jb250ZW50L2V4dC9zZXJ2aWNlcy9pbnN0YWdyYW0tZW1iZWQvMS5zY2hlbWEudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQWEsUUFBQSxxQkFBcUIsR0FBRztJQUNuQyxLQUFLLEVBQUUsb0ZBQW9GO0lBQzNGLFNBQVMsRUFBRSw4Q0FBOEM7SUFDekQsT0FBTyxFQUFFLGlCQUFpQjtJQUMxQixhQUFhLEVBQUUseUJBQXlCO0lBQ3hDLE1BQU0sRUFBRSxRQUFRO0lBQ2hCLFlBQVksRUFBRTtRQUNaLE1BQU0sRUFBRTtZQUNOLE1BQU0sRUFBRSxRQUFRO1lBQ2hCLE1BQU0sRUFBRTtnQkFDTiw0Q0FBNEM7YUFDN0M7U0FDRjtRQUNELFlBQVksRUFBRTtZQUNaLE1BQU0sRUFBRSxRQUFRO1lBQ2hCLFlBQVksRUFBRTtnQkFDWixhQUFhLEVBQUU7b0JBQ2IsTUFBTSxFQUFFLFNBQVM7b0JBQ2pCLFNBQVMsRUFBRSxLQUFLO2lCQUNqQjtnQkFDRCxNQUFNLEVBQUU7b0JBQ04sTUFBTSxFQUFFLFFBQVE7b0JBQ2hCLGFBQWEsRUFBRSx1RkFBdUY7aUJBQ3ZHO2FBQ0Y7WUFDRCxVQUFVLEVBQUU7Z0JBQ1YsYUFBYTtnQkFDYixNQUFNO2FBQ1A7U0FDRjtLQUNGO0lBQ0QsVUFBVSxFQUFFO1FBQ1YsWUFBWTtRQUNaLE1BQU07S0FDUDtDQUNGLENBQUEifQ==